/* eslint-disable */
import { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { useDispatch, useSelector } from 'react-redux';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { toast } from 'react-toastify';
import countries from 'countries-list';
import Form from 'react-bootstrap/Form';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { Select, InputLabel, FormControl } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';


// material Components
import { Card, Table, Box, TextField, Modal, Button, Tooltip, Alert, Checkbox, Stack } from '@mui/material';
import { TableRow, TableBody, TableCell, Container, Typography, TableContainer, TablePagination } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton, Snackbar, OutlinedInput } from '@mui/material';
import { MenuItem, ListItemText, Chip, TableHead } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import TabList from '@mui/lab/TabList';
import Tab from '@mui/material/Tab';

// React Icons
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ClearIcon from '@mui/icons-material/Clear';
import EmailIcon from '@mui/icons-material/Email';
import NoteIcon from '@mui/icons-material/Note';
import HistoryIcon from '@mui/icons-material/History';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';

// Redux slices
import { fetchGlobalData } from 'src/redux/globalData/globalDataSlice';
import { fetchEmailTemplate, resetGetInvoiceData } from '../../../redux/auth/authSlice';
import { 
  setSearchQuery as setReduxSearchQuery, 
  setSearchDropValue as setReduxSearchDropValue, 
  setSelectedTabValue as setReduxSelectedTabValue,
  clearSearch 
} from '../../../redux/globalData/usersSearchSlice';

// components
import { formatDate, getModalBoxStyle, userDropOptions } from '../../../utils/commonFunc';
import { useSSNVerification } from '../../../components/SSNVerification';
import SSNVerificationModal from '../../../components/SSNVerificationModal';
import TooltipWithCopy from '../../../components/TooltipWithCopy';
import { ListHead, ListToolbar } from '../../../sections/@dashboard/table';
import SearchNotFound from '../../../components/SearchNotFound';
import HoursModal from '../../../components/MonthlyHoursModal';
import { MultipleUsersPDF } from './MultipleUsersPDF';
import Scrollbar from '../../../components/Scrollbar';
import Page from '../../../components/Page';
import Loader from '../../../components/Loader';
import Iconify from '../../../components/Iconify';
import PermanentDeactivatedUser from './PermanentDeactivatedUser';
import { ConstructionOutlined } from '@mui/icons-material';

// ----------------------------------------------------------------------
const TABLE_HEAD = [
  { id: 'userId', label: 'Id', alignRight: false },
  { id: 'name', label: 'Name', alignRight: false },
  {
    id: 'totalInvoiceAmount',
    label: 'Total Invoice Amount',
    alignRight: false,
  },
  { id: 'isSSNVerified', label: 'SSN Verified', alignRight: false },
  { id: 'invoiceCount', label: 'Invoice Count', alignRight: false },
  { id: 'createdDate', label: 'Created Date', alignRight: false },
  { id: 'profession', label: 'Profession', alignRight: false },
  { id: 'incomeTax', label: 'Tax', alignRight: false },
  { id: 'fakturaFee', label: 'Invozio fee', alignRight: false },
  { id: 'monthlyHours', label: 'Monthly Hours', alignRight: false },
  { id: 'bankDetails', label: 'Bank Details', alignRight: false },
  { id: 'invoice', label: 'Invoice' },
  { id: 'actions', label: 'Actions' },
];

const deactivatedHead = [
  { id: 'userId', label: 'Id', alignRight: false },
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'email', label: 'E-email', alignRight: false },
  { id: 'ssn', label: 'SSN', alignRight: false },
  { id: 'createdDate', label: 'Created Date', alignRight: false },
  { id: 'action', label: 'Action', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  // if (query) {
  //   const searchRegex = new RegExp(escapeRegExp(query), "i");
  //   return filter(orgArray, (_row) =>
  //     Object.keys(_row).some((field) => {
  //       if (_row[field]) return searchRegex.test(_row[field].toString());
  //       return false;
  //     })
  //   );
  // }

  return stabilizedThis?.map((el) => el[0]);
}

export default function Users() {
  // Redux selectors for search state
  const searchQuery = useSelector((state) => state.usersSearch.searchQuery);
  const searchDropValue = useSelector((state) => state.usersSearch.searchDropValue);
  const selectedTabValue = useSelector((state) => state.usersSearch.selectedTabValue);
  
  const [selectedOption, setSelectedOption] = useState('');
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState([]);
  const [personName, setPersonName] = useState([]);
  const [isSnackBarOpen, setIsSnackBarOpen] = useState(false);
  const [viewSurveyAnswers, setViewSurveyAnswers] = useState(false);
const [surveyAnswers, setSurveyAnswers] = useState([]);
const [surveyAnswersLoading, setSurveyAnswersLoading] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState({
    bankDetails: false,
    sandEmail: false,
  });
  const [toggleNote, setToggleNote] = useState(false);
  const [autoHideDuration, setAutoHideDuration] = useState(3000);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertStatus, setAlertStatus] = useState('success');
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('desc');
  const [totalCount, setTotalCount] = useState(0);
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('createdDate');
  // const [searchQuery, setSearchQuery] = useState(getselectedUser || '');
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [loading, setLoading] = useState(false);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [emailType, setemailType] = useState(null);
  const currentYear = new Date().getUTCFullYear();
  const [toggleHourModal, settoggleHourModal] = useState(false);

  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [getUserId, setGetUserId] = useState(0);

  const [incomeData, setincomeData] = useState({
    values: {},
    statusCode: null,
  });

  const [showUserDetails, setShowUserDetails] = useState(null);
  const [originalUsers, setOriginalUsers] = useState([]);
  const [isAllSelected, setAllSelected] = useState(false);
  const [templateData, setTemplateData] = useState({
    Subject: '',
    content: '<p></p>',
    templateFromName: '',
  });

  const [commentList, setcommentList] = useState([]);
  const [chooseBankName, setChooseBankName] = useState('');
  const [bankName, setBankName] = useState('');
  const [activateModal, setActivateModal] = useState({
    id: null,
    show: false,
    isActive: 'false',
  });
  const [permanentDeactivate, setpermanentDeactivate] = useState({
    userId: null,
    show: false,
  });  
  const [accidentalReactivate, setaccidentalReactivate] = useState({
    userId: null,
    show: false,
  });
  const [notesContent, setNotesContent] = useState('');
  const [reasonForDeactivated, setreasonForDeactivated] = useState('');
  const [isReasonEmpty, setisReasonEmpty] = useState(false);
  const [isNotesContentEmpty, setIsNotesContentEmpty] = useState(false);
  const [openPDFModal, setOpenPDFModal] = useState(false);
  const [isSendLink, setisSendLink] = useState({
    id: null,
    show: false,
  });
  const [deleteUserModal, setDeleteUserModal] = useState({ show: false, userId: null });
  const [ssnVerificationModal, setSsnVerificationModal] = useState({
    show: false,
    expectedData: null,
    sparData: null,
    reason: '',
    status: '',
    userId: null,
    ssn: null,
    isSsnValid: null,
    isPending: false,
  });

  const [noteType, setNoteType] = useState('General'); // Dropdown value
    const [surveyNotes, setSurveyNotes] = useState([]);  // Survey notes/questions
    const [surveyLoading, setSurveyLoading] = useState(false);
    const [surveyRatings, setSurveyRatings] = useState({}); // { [SurveyQuestionId]: rating }
    const [surveySubmitted, setSurveySubmitted] = useState(false); // <-- Add this state
   const [customQuestion, setCustomQuestion] = useState('');
  const [customRating, setCustomRating] = useState(0);
  const [surveyReloaded, setSurveyReloaded] = useState(false); 
    const isMobile = useMediaQuery('(max-width:600px)');
    const [selectedUserId, setSelectedUserId] = useState([]);
  
  // Use the shared SSN Verification hook
  const { handleSSNVerification: ssnVerificationAPI, loading: ssnLoading } = useSSNVerification();
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { emailTemplate, isLoading } = useSelector((data) => data.auth);
  const banksData = useSelector((state) => state?.globalData?.data?.banks);

  const {
    reset,
    watch,
    register,
    handleSubmit,
    resetField,
    formState: { errors },
  } = useForm();

  const ssnNumber = watch('ssn');
  const years = Array(currentYear - (currentYear - (currentYear - 2021)))
    .fill('')
    ?.map((v, idx) => currentYear - idx);

  const {
    reset: resetForm2,
    register: registerForm2,
    handleSubmit: handleSubmitForm2,
    formState: { errors: errorsForm2 },
  } = useForm();

  const {
    reset: resetForm3,
    register: registerForm3,
    handleSubmit: handleSubmitForm3,
    formState: { errors: errorsForm3 },
  } = useForm();

  useEffect(() => {
    dispatch(fetchEmailTemplate());
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchUsers();
    }, 600);
    return () => clearTimeout(timeoutId);
  }, [page, rowsPerPage, selectedTabValue, searchQuery, searchDropValue]);

  const { search } = useLocation();
  const { userId: userIdFromRoute } = useParams();
  const hasProcessedRouteParam = useRef(false);

  useEffect(() => {
    dispatch(fetchGlobalData());
  }, [dispatch]);

  useEffect(() => {
    if (userIdFromRoute && !hasProcessedRouteParam.current) {
      hasProcessedRouteParam.current = true;
      dispatch(setReduxSearchQuery(userIdFromRoute.toString()));
      dispatch(setReduxSearchDropValue(1));
    }
  }, [userIdFromRoute, dispatch]);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      let URL;
      const activeStatus = userIdFromRoute ? 1 : selectedTabValue;
      
      if (searchDropValue && searchQuery) {
        URL = `/admin/user?PageSize=${rowsPerPage}&PageNumber=${
          page + 1
        }&active=${activeStatus}&searchQuery=${searchQuery}&SearchColumn=${searchDropValue}`;
      } else {
        URL = `/admin/user?PageSize=${rowsPerPage}&PageNumber=${
          page + 1
        }&active=${activeStatus}&searchQuery=${searchQuery}`;
      }

      const res = await axios.get(URL);
      if (res?.status === 200) {
        setLoading(false);
        const users = res?.data?.response?.map((ele) => ({
          ...ele,
          isEdit: false,
        }));

        setOriginalUsers(users);

        const userId = new URLSearchParams(search).get('notificationVal');

        const filteredRows = applySortFilter(users, getComparator(order, orderBy), users);
        const notificationFilteredList = filteredRows?.map((item) => ({
          ...item,
          isSelected: item.userId === Number(userId),
        }));
        selectAllClick(isAllSelected, notificationFilteredList);
        setUsers(notificationFilteredList);
        setTotalCount(res.data.totalCount);

        setFilteredUsers(notificationFilteredList);
      }
    } catch (err) {
      if (err?.response?.data?.message === 'Something went wrong please try again after sometime.') {
        fetchUsers();
      } else {
        setUsers([]);
        setLoading(false);
      }
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
    const filteredRows = applySortFilter(
      filteredUsers,
      getComparator(isAsc ? 'desc' : 'asc', orderBy),
      event.target.value,
      originalUsers
    );
    setFilteredUsers(filteredRows);
  };

  const selectAllClick = (isSelected, filteredUsers) => {
    if (isSelected) {
      const newSelecteds = filteredUsers?.map((n) => n.userId);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleSelectAllClick = (event) => {
    setAllSelected(event.target.checked);
    selectAllClick(event.target.checked, filteredUsers);
  };

const handleDownloadSurvey = async () => {
  try {
    const response = await axios.get('/AdminNotesSurvey/export-survey?surveyType=5', {
      responseType: 'blob',
    });

    let fileName = 'survey-notes.csv';
    const disposition = response.headers['content-disposition'];
    if (disposition && disposition.indexOf('filename=') !== -1) {
      fileName = disposition.split('filename=')[1].replace(/"/g, '').trim();
    }

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    toast.error('Failed to download survey notes.');
  }
};

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected?.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setSelected(selected);
    setPage(0);
  };

  const handleFilter = (event) => {
    const newSearchQuery = event.target.value;
    dispatch(setReduxSearchQuery(newSearchQuery));
  };

  // Wrapper function to handle searchDropValue changes
  const handleSetSearchDropValue = (value) => {
    dispatch(setReduxSearchDropValue(value));
  };

  // Handle back navigation while preserving search state
  const handleUserPageBackNavigation = () => {
    console.log('Back navigation clicked, current search state:', { searchQuery, searchDropValue });
    navigate(-1);
  };

  const handleDelete = async () => {
    await deleteUsers();
  };

  const deleteUsers = async () => {
    try {
      setLoading(true);
      await axios.delete('/admin/user', { data: selected }).then((res) => {
        const isDeletedCount = res?.data?.response?.isDeleted;
        if (isDeletedCount > 0) {
          setAlertMessage(
            `${
              isDeletedCount === res?.data?.totalCount
                ? `Selected ${isDeletedCount > 1 ? 'users' : 'user'} has been deleted successfully.`
                : `${isDeletedCount} ${isDeletedCount > 1 ? 'users' : 'user'} out of ${
                    res?.data?.totalCount
                  } has been deleted successfully.`
            }`
          );
          setAlertStatus('success');
        } else {
          setAlertMessage(`Selected ${isDeletedCount > 1 ? 'users' : 'user'} can't been deleted.`);
          setAlertStatus('error');
        }
        setIsSnackBarOpen(true);
        fetchUsers();
      });
    } catch (err) {
      setAlertMessage(err?.response?.data?.message);
      setAlertStatus('error');
      setIsSnackBarOpen(true);
    } finally {
      setLoading(false);
      setSelected([]);
    }
  };

  // const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - users.length) : 0;

  const isNotFound = filteredUsers?.length === 0;

  const handleRowClick = (event, id) => {
    console.log('Row clicked, current search state:', { searchQuery, searchDropValue });
    navigate(`/dashboard/user/invoices/${id}`);
  };

  const activateOrDeactivateUser = async (userId, type, checkUser) => {
    setLoading(true);
    try {
      if (checkUser?.isBelowEighteen && checkUser?.isParentalEmailReceived === false) {
        const response = await axios.put(`/admin/user/activate-below-eighteen-user/${userId}`);
        if (response?.data?.statusCode === 200) {
          setAlertMessage(`User is activated successfully.`);
          await fetchUsers();
        }
      } else {
        await axios.put(`/admin/user/${userId}?isActive=${type}`).then(async () => {
          setAlertMessage(`UserId #${userId} has been ${type === 'true' ? 'Activated' : 'Deactivated'} successfully.`);
          setAlertStatus('success');
          setAutoHideDuration(2000);
          setIsSnackBarOpen(true);
          await fetchUsers();
          setActivateModal({ show: false });
        });
      }
    } catch (err) {
      setActivateModal({ show: false });
      setAlertMessage(err?.response?.data?.message);
      setAlertStatus('error');
      setIsSnackBarOpen(true);
    } finally {
      setActivateModal({ show: false });
      setLoading(false);
    }
  };

  const getUserDetails = (id) => {
    const user = users.find((users) => users.userId === id);
    setShowUserDetails(user);
    setShowEditModal(true);
    reset({
      userAccountType: (user.accountType === 1 && 'Private Account') || (user.accountType === 2 && 'Business Account'),
      firstName: user?.firstName,
      lastName: user?.lastName,
      email: user?.email,
      ssn: user?.ssn,
      country: user?.country,
      phoneNo: user?.phoneNo,
      dateOfBirth: user?.dateOfBirth,
      city: user?.city,
      address: user?.address,
      zipCode: user?.zipCode,
      incomeTax: user?.incomeTax,
      fakturaFee: user?.fakturaFee,
      organisation: user?.organisation,
      profession: user?.profession,
      accountType: user?.accountType,
    });
  };

  const editUserDetails = async (values) => {
    try {
      setLoading(true);
      await axios.put('/admin/user/edit-employee', {
        ...values,
        id: showUserDetails.userId,
        dateOfBirth: selectedOption === 'DOB' ? values.dateOfBirth : '',
        ssn: selectedOption === 'SSN' ? values.ssn : '',
        accountType: values.userAccountType === 'Private Account' ? 'Contract' : 'Business',
      });
      setShowEditModal(false);
      setAlertMessage('Details has been updated successfully.');
      setAlertStatus('success');
      setAutoHideDuration(3000);
      setIsSnackBarOpen(true);
      await fetchUsers();
    } catch (err) {
      setAlertMessage(err?.response?.data?.message);
      setAlertStatus('error');
      setAutoHideDuration(3000);
      setIsSnackBarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const editBankDetails = async (values) => {
    try {
      setLoading(true);
      const response = await axios.put('/admin/user/update-bankdetails', {
        id: selectedUser.customerSalaryInformation[0]?.id,
        userId: selectedUser.userId,
        bank: values.chooseBankName === 'Other banks' ? values.createBankName : chooseBankName,
        bicNumber: values.bicNumber || '',
        ibanNumber: values.ibanNumber || '',
        accountNumber: values.accountNumber || '',
        clearingNumber: values.clearingNumber || '',
      });
      setBankName('');
      setChooseBankName('');
      resetForm2({ bankDetails: {} });
      setIsOpenModal({ bankDetails: false });
      setAlertMessage(response?.data.message);
      setAlertStatus('success');
      setAutoHideDuration(3000);
      setIsSnackBarOpen(true);
      await fetchUsers();
    } catch (err) {
      setAlertMessage(err?.response?.data?.message);
      setAlertStatus('error');
      setAutoHideDuration(3000);
      setIsSnackBarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const newDetails = [];

  Object.keys(countries.countries).forEach((code) => {
    // if (countries.countries[code].continent === 'EU') {
    newDetails.push({ label: countries.countries[code].name });
    // }
  });

  const handleSnackBarClose = () => {
    setIsSnackBarOpen(false);
  };

  const handleOpenModal = (id) => {
    setIsOpenModal({ bankDetails: true });
    const filteredUser = filteredUsers.find((u) => u.userId === id);

    resetForm2({
      bankDetails: {
        chooseBankName,
        createBankName: filteredUser.customerSalaryInformation[0]?.bank,
        bicNumber: filteredUser.customerSalaryInformation[0]?.bicNumber,
        ibanNumber: filteredUser.customerSalaryInformation[0]?.ibanNumber,
        clearingNumber: filteredUser.customerSalaryInformation[0]?.clearingNumber,
        accountNumber: filteredUser.customerSalaryInformation[0]?.accountNumber,
      },
    });
    setSelectedUser(filteredUser);
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value
    );
  };

  const onSendEmail = () => {
    const selectedUsers = users.filter((item) => selected.includes(item.userId));
    setPersonName(selectedUsers?.map((item) => item.email));
    setIsOpenModal({ sandEmail: true });
  };

  const handleSendEmail = async (e) => {
    e.preventDefault();
    try {
      setIsOpenModal(false);
      const response = await axios.post('/adminemailtemplate/email', {
        ...templateData,
        toEmails: personName,
      });
      setAlertStatus('success');
      setAlertMessage(response?.data.response);
      setAutoHideDuration(3000);
      setIsSnackBarOpen(true);
    } catch (err) {
      setAlertStatus('error');
      if (err.response.data) {
        setAlertMessage(err?.response?.data?.message);
      } else {
        setAlertMessage(err.message);
      }
      setAutoHideDuration(3000);
      setIsSnackBarOpen(true);
    }
  };

  const handleEmailType = (e) => {
    const value = e.target.value;
    setemailType(value);
  };

  const handleSendAllEmails = async (type) => {
    try {
      if (!templateData?.Subject || !templateData?.templateFromName) {
        return toast.error('Please fill emails fields.');
      }

      setIsOpenModal(false);
      setemailType(null);
      const response = await axios.post(`/adminemailtemplate/send-email-allusers?type=${type}`, {
        ...templateData,
        toEmails: personName,
      });

      if (response?.data?.response) {
        toast.success(response?.data?.response);
      } else {
        toast.error(response?.data);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    if (emailType !== null) {
      if (emailType === 1) {
        handleSendAllEmails(1);
      } else if (emailType === 2) {
        handleSendAllEmails(2);
      } else {
        handleSendAllEmails(3);
      }
    }
  }, [emailType]);

  useEffect(() => {
    if (watch('emailTemplate.selectedTemplate')) {
      const removedDuplicate = [];
      const userData = watch('emailTemplate.selectedTemplate')?.emailTemplateUserList;
      if (selected?.length > 0) {
        const selectedUsers = users.filter((item) => selected.includes(item.userId));
        const allEmails = [
          ...userData?.map((item) => item.signUpUser.email),
          ...selectedUsers?.map((item) => item.email),
        ];
        removedDuplicate.push(...allEmails.filter((item, index) => allEmails.indexOf(item) === index));
      }
      setTemplateData(() => ({
        content: watch('emailTemplate.selectedTemplate')?.html,
        Subject: watch('emailTemplate.selectedTemplate')?.templateSubject,
        templateFromName: watch('emailTemplate.selectedTemplate')?.templateFromName,
      }));
      setPersonName(removedDuplicate?.length > 0 ? removedDuplicate : userData?.map((item) => item?.signUpUser?.email));
    }
  }, [watch('emailTemplate.selectedTemplate')]);

  const handleBankChange = (event) => {
    setChooseBankName(event.target.value);
  };

  // Bank Name select
  useEffect(() => {
    if (Object.keys(selectedUser)?.length > 0) {
      setBankName(Object.keys(selectedUser)?.length > 0 ? selectedUser.customerSalaryInformation[0]?.bank : '');
      setChooseBankName(
        banksData.some((item) => item.description === bankName) || !bankName ? bankName : 'Other banks'
      );
    }
  }, [selectedUser, bankName]);

  // Add Notes
  const addnoteToggle = (id) => {
    setToggleNote(true);
    setSelectedUserId(id);
    setNoteType('General');
    setSurveyNotes([]);
    setSurveyRatings({});
    const filteredUser = filteredUsers.find((u) => u.userId === id);
    resetForm3({
      description: '',
    });
    setSelectedUser(filteredUser);
  };

  const postAddnotes = async () => {
    try {
      if (notesContent === '' || notesContent.trim() === '') {
        setIsNotesContentEmpty(true);
        setNotesContent('');
      } else {
        setIsNotesContentEmpty(false);
        setLoading(true);
        const response = await axios.post('/admin/user/notes', {
          userId: selectedUser?.userId,
          invoiceNumber: 0,
          description: notesContent,
           notesType: noteType === "General" ? 1 : noteType === "Economic" ? 7 : null,
        });

        if (response?.status === 200) {
          setLoading(false);
          fetchCommentList();
          setNotesContent('');
          toast.success('Notes added successfully');
          fetchUsers();
        } else {
          setLoading(false);
          toast.error('Server Error! Please try again');
        }
      }
    } catch (err) {
      setLoading(false);
      if (err?.response?.data) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error(err?.message);
      }
      setAlertStatus('error');
    } finally {
      setLoading(false);
    }
  };

  const fetchCommentList = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`admin/user/get-notes?userId=${selectedUser?.userId}`);
      setcommentList(res?.data?.response);
    } catch (err) {
      setcommentList([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSendLink = async (data) => {
    const { userId } = data?.row;
    try {
      setLoading(true);
      const url = `/admin/user/send-verifymail-to-customer`;
      const response = await axios.post(url, [userId]);
      if (response?.data?.message === 'Success') {
        setAlertMessage('Email sent successfully');
        setAlertStatus('success');
        setIsSnackBarOpen(true);
        setisSendLink({
          show: false,
        });
      } else {
        throw new Error(response?.data?.message || 'Unexpected error');
      }
    } catch (err) {
      setAlertMessage(err?.response?.data?.message || err.message);
      setAlertStatus('error');
      setIsSnackBarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const [toggleuserInfo, settoggleuserInfo] = useState(false);
  const [getDeactivateduserInfo, setgetDeactivateduserInfo] = useState(null);
  const getDeactivatedNotes = async (userId) => {
    try {
      setLoading(true);
      const response = await axios.get(`/admin/user/get-notes?userId=${userId}&IsPermanentDeativatedNote=true`);
      setgetDeactivateduserInfo(response?.data?.response);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const getUserDetailsInfo = (id) => {
    settoggleuserInfo(true);
    getDeactivatedNotes(id);
  };

  const handlePermanentDeactivateUser = async (e, userId) => {
    e.preventDefault();
    try {
      const trimmedReason = reasonForDeactivated.trim();
      if (trimmedReason === '') {
        setisReasonEmpty(true);
      } else {
        setLoading(true);
        setisReasonEmpty(false);
        const result = await axios.put(`/admin/user/permanent-deactivate-user/${userId}?description=${trimmedReason}`);
        if (result?.data?.statusCode === 200) {
          toast.success('User is deactivated successfully.');
          setpermanentDeactivate(false);
          setLoading(false);
          setreasonForDeactivated('');
          await fetchUsers();
        }
      }
    } catch (error) {
      if (error?.response?.status === 500) {
        toast.error('Fortnox error occurred. Please refresh and try again.');
      } else {
        toast.error(error?.message);
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    if (toggleNote) {
      fetchCommentList();
    }
  }, [toggleNote, selectedUser]);

  const downloadData = async (userId) => {
    setLoading(true);
    try {
      const filteredUser = filteredUsers.find((u) => u.userId === userId);
      setGetUserId(filteredUser?.userId);

      const res = await axios.get(`admin/adminsalary/yearly-hours?id=${userId}&year=${selectedYear}`);
      if (res?.status === 200) {
        setLoading(false);

        setincomeData({
          values: res?.data?.response,
          statusCode: res?.status,
        });
      } else {
        toast.error('Server Error! Please try again');
      }
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message);
    }
  };

  const handleManualSSNVerification = async (userId) => {
    try {
      setLoading(true);
      const response = await axios.get(`/admin/invoice/ssn-verified-manually/${userId}`);
      if (response.status === 200) {
        setAlertMessage('SSN verified manually successfully!');
        setAlertStatus('success');
        setIsSnackBarOpen(true);
        setSsnVerificationModal({ 
          show: false, 
          expectedData: null, 
          sparData: null, 
          reason: '', 
          status: '', 
          userId: null, 
          ssn: null, 
          isSsnValid: null,
          isPending: false 
        });
        setTimeout(() => {
          fetchUsers();
        }, 500);
      }
    } catch (error) {
      setLoading(false);
      setAlertMessage(error?.response?.data?.message || 'Failed to verify SSN manually');
      setAlertStatus('error');
      setIsSnackBarOpen(true);
    }
    finally {
      setLoading(false);
    }
  };

  const boxStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  const commentStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    width: '60%',
    height: '80%',
    // overflow: 'scroll',
    marginBottom: '40',
    p: 3,
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  const handleDeleteUser = async (userId) => {
    try {
      setLoading(true);
      const response = await axios.delete(`/admin/user/delete-user/${userId}`);
      if (response?.data?.statusCode === 200) {
        toast.success(response?.data?.response || "User deleted successfully.");
        await fetchUsers();
      } else {
        toast.error('Server Error! Please try again');
      }
    } catch (err) {
      setDeleteUserModal({ show: false });
      toast.error(err?.response?.data?.message);
      setLoading(false);

    } finally {
      setDeleteUserModal({ show: false });
      setLoading(false);
    }
  };

  const handleUploadToComplyCube = async (userId) => {
    try {
      setLoading(true);
      const response = await axios.post(`admin/user/send-details-complycube?userId=${userId}`);
        console.log(response,"response");
      if (response?.data?.statusCode === 200) {
        setAlertMessage('User uploaded to ComplyCube successfully');
        setAlertStatus('success');
        setIsSnackBarOpen(true);
        await fetchUsers();
      }
      else {
        console.log(response,"response");
        setAlertMessage(response?.data?.message || 'Failed to upload to ComplyCube');
        setAlertStatus('error');
        setIsSnackBarOpen(true);
      }
    } catch (err) {
      setAlertMessage(err?.response?.data?.message || 'Failed to upload to ComplyCube');
      setAlertStatus('error');
      setIsSnackBarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeStatusOfDeactivate = async () => {
    try {
      setLoading(true);
      const response = await axios.post(`admin/user/permanent-reactivate-user/${accidentalReactivate?.userId}`);
      if (response.data?.statusCode === 200) {
        setLoading(false);
        toast.success('User is reactivated successfully');
        setaccidentalReactivate({
          show: false,
        });
        await fetchUsers();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      setLoading(false);
    }
  };

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
    if (selectedOption === 'SSN') {
      resetField('dateOfBirth', { defaultValue: '' });
    } else if (selectedOption === 'DOB') {
      resetField('ssn', { defaultValue: '' });
    }
  };

  useEffect(() => {
    if (showUserDetails?.dateOfBirth === '' || showUserDetails?.dateOfBirth === null) {
      setSelectedOption('SSN'); // Select SSN
    } else if (showUserDetails?.dateOfBirth && showUserDetails?.ssn) {
      setSelectedOption('SSN');
    } else if (showUserDetails?.ssn === '' || showUserDetails?.ssn === null) {
      setSelectedOption('DOB'); // Select DOB
    }
  }, [showUserDetails]);

  const renderUsers = () => (
    <>
      <ListToolbar
        onDelete={handleDelete}
        onFilter={handleFilter}
        onSendEmail={onSendEmail}
        searchQuery={searchQuery}
        numSelected={selected?.length}
        hideDeleteButton={selectedTabValue !== '3' && 'true'}
        dropOptions={userDropOptions}
        searchDropValue={searchDropValue}
        setSearchDropValue={handleSetSearchDropValue}
      />
      <Scrollbar>
        <TableContainer sx={{ minWidth: 800 }}>
          <Table className={`${selectedTabValue === '5' ? '' : 'user-table'}`}>
            <ListHead
              order={order}
              orderBy={orderBy}
              headLabel={selectedTabValue !== '5' ? TABLE_HEAD : deactivatedHead}
              rowCount={users?.length}
              numSelected={selected?.length}
              onRequestSort={handleRequestSort}
              onSelectAllClick={handleSelectAllClick}
              hideCheckboxColumnHeader={selectedTabValue === '5' ? true : false}
            />
            <TableBody>
              {(filteredUsers?.length &&
                filteredUsers?.map((row) => {
                  const {
                    userId,
                    ssn,
                    firstName,
                    lastName,
                    totalInvoiceAmount,
                    isSsnValid,
                    invoiceCount,
                    createdDate,
                    profession,
                    incomeTax,
                    fakturaFee,
                    isEdit,
                    isActive,
                    notes,
                    isPermanentDeactivate,
                    sparSsnInformation,
                  } = row;

                  const isItemSelected = selected.indexOf(userId) !== -1;
                  return (
                    <>
                      {selectedTabValue !== '5' ? (
                        <TableRow
                          key={userId}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                          style={{
                            backgroundColor: row?.isSelected ? 'lightgrey' : '',
                            cursor: 'pointer',
                          }}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, userId)}
                              onClick={(event) => event.stopPropagation()}
                              size="small"
                            />
                          </TableCell>

                          <TableCell
                            align="left"
                            onClick={(event) => handleRowClick(event, userId)}
                            style={{ fontSize: '13px', padding: '6px' }}
                          >
                            {userId}
                          </TableCell>
                          {`${firstName} ${lastName}`?.length >= 18 ? (
                            <Tooltip title={`${firstName} ${lastName}`} arrow placement="top">
                              <TableCell
                                align="left"
                                onClick={(event) => {
                                  getUserDetails(userId);
                                  event.stopPropagation();
                                }}
                                style={{ fontSize: '13px', padding: '6px' }}
                              >
                                {`${firstName} ${lastName}`?.substring(0, 18).concat('...')}
                              </TableCell>
                            </Tooltip>
                          ) : (
                            <TableCell
                              align="left"
                              className="userColumn"
                              onClick={(event) => {
                                getUserDetails(userId);
                                event.stopPropagation();
                              }}
                            >
                              {`${firstName} ${lastName}`}
                            </TableCell>
                          )}

                          <TableCell
                            align="left"
                            className="userColumn"
                            onClick={(event) => handleRowClick(event, userId)}
                          >
                            {totalInvoiceAmount}
                          </TableCell>
                          <TableCell
                            align="left"
                            className="userColumn"
                            style={{ cursor: ssn && isSsnValid !== null ? 'pointer' : 'default' }}
                            onClick={(event) => {
                              if (isSsnValid === null) {
                                event.stopPropagation();
                                return;
                              }
                              
                              if (ssn && isSsnValid !== null) {
                                event.stopPropagation();
                                
                                if (sparSsnInformation) {
                                  try {
                                   console.log('sparSsnInformation', sparSsnInformation);
                                    const parsedData = JSON.parse(sparSsnInformation);
                                    if (parsedData.status === 'failed' || parsedData.status === 'success') {
                                      // Check if we have actual SPAR data structure
                                      const hasExpectedData = parsedData.details?.expected;
                                      const hasSparData = parsedData.details?.spar;
                                      
                                      // If no expected/spar data (manual verification), use row data
                                      const expectedData = hasExpectedData ? parsedData.details.expected : {
                                        firstName: row.firstName,
                                        lastName: row.lastName,
                                        dateOfBirth: row.dateOfBirth,
                                        address: row.address,
                                        city: row.city,
                                        zipCode: row.zipCode,
                                      };
                                      
                                      const sparData = hasSparData ? parsedData.details.spar : {
                                        firstName: row.firstName,
                                        lastName: row.lastName,
                                        dateOfBirth: row.dateOfBirth,
                                        address: row.address,
                                        city: row.city,
                                        zipCode: row.zipCode,
                                      };
                                      
                                      setSsnVerificationModal({
                                        show: true,
                                        expectedData: expectedData,
                                        sparData: sparData,
                                        reason: parsedData.reason || 'Verification successful',
                                        status: parsedData.status,
                                        userId: row.userId,
                                        ssn: row.ssn,
                                        isSsnValid: isSsnValid,
                                        isPending: false,
                                      });
                                      return;
                                    }
                                  } catch (err) {
                                    console.error('Failed to parse sparSsnInformation', err);
                                  }
                                }
                                
                                if (!isSsnValid) {
                                  // Open modal with pending state for re-verification
                                  setSsnVerificationModal({
                                    show: true,
                                    expectedData: {
                                      firstName: row.firstName,
                                      lastName: row.lastName,
                                      dateOfBirth: row.dateOfBirth,
                                    },
                                    sparData: null,
                                    reason: '',
                                    status: '',
                                    userId: row.userId,
                                    ssn: row.ssn,
                                    isSsnValid: null,
                                    isPending: true,
                                  });
                                }
                              } else {
                                handleRowClick(event, userId);
                              }
                            }}
                          >
                            {ssn ? (
                              isSsnValid === true ? (
                                <Tooltip title="Click to view verification details">
                                  <span style={{ color: 'green', fontWeight: '500', textDecoration: 'underline', cursor: 'pointer' }}>
                                    {ssn} ✓
                                  </span>
                                </Tooltip>
                              ) : isSsnValid === false ? (
                                <Tooltip title="Click to verify SSN">
                                  <span style={{ color: 'orange', textDecoration: 'underline' }}>
                                    {ssn}
                                  </span>
                                </Tooltip>
                              ) : (
                                <Tooltip title="Click to verify SSN">
                                  <span 
                                    style={{ color: 'gray', textDecoration: 'underline', cursor: 'pointer' }}
                                    onClick={() => {
                                      // Open modal with pending state instead of calling API directly
                                      setSsnVerificationModal({
                                        show: true,
                                        expectedData: {
                                          firstName: row.firstName,
                                          lastName: row.lastName,
                                          dateOfBirth: row.dateOfBirth,
                                        },
                                        sparData: null,
                                        reason: '',
                                        status: '',
                                        userId: row.userId,
                                        ssn: row.ssn,
                                        isSsnValid: null,
                                        isPending: true,
                                      });
                                    }}
                                  >
                                    {ssn}
                                  </span>
                                </Tooltip>
                              )
                            ) : ""}
                          </TableCell>

                          <TableCell
                            align="left"
                            className="userColumn"
                            onClick={(event) => handleRowClick(event, userId)}
                          >
                            {invoiceCount}
                          </TableCell>

                          <TableCell align="left" style={{ fontSize: '13px', padding: '6px' }}>
                            {createdDate?.split('T')[0]}
                          </TableCell>

                          <TableCell align="left" style={{ fontSize: '13px', padding: '6px' }}>
                            {profession?.length > 10 ? (
                              <Tooltip title={profession}> {profession.substring(0, 10).concat('...')} </Tooltip>
                            ) : (
                              profession
                            )}
                          </TableCell>

                          <TableCell align="left" style={{ fontSize: '13px', padding: '6px' }}>
                            {incomeTax}
                          </TableCell>

                          <TableCell align="center" style={{ fontSize: '13px', padding: '6px' }}>
                            {fakturaFee}
                          </TableCell>

                          <TableCell align="left" style={{ padding: '6px' }}>
                            <Tooltip title="Hours">
                              <Button
                                variant="contained"
                                onClick={() => {
                                  downloadData(userId);
                                  settoggleHourModal(true);
                                }}
                                style={{
                                  width: 50,
                                  minWidth: '50px',
                                  fontSize: '12px',
                                }}
                              >
                                Hours
                              </Button>
                            </Tooltip>
                          </TableCell>

                          <TableCell align="left" style={{ padding: '6px' }}>
                            <Tooltip title="View">
                              <Button
                                variant="contained"
                                onClick={() => {
                                  handleOpenModal(userId);
                                }}
                                style={{
                                  width: 50,
                                  minWidth: '50px',
                                  fontSize: '12px',
                                }}
                              >
                                View
                              </Button>
                            </Tooltip>
                          </TableCell>

                          <TableCell align="left" style={{ padding: '6px' }}>
                            <Tooltip title="Create Invoice">
                              <Button
                                variant="contained"
                                onClick={() => {
                                  dispatch(resetGetInvoiceData())
                                  navigate(`/dashboard/invoice-tool/${userId}`);
                                }}
                                style={{
                                  width: 102,
                                  minWidth: '102px',
                                  fontSize: '12px',
                                  padding: '6px 4px',
                                }}
                              >
                                Create Invoice
                              </Button>
                            </Tooltip>
                          </TableCell>

                          <TableCell
                            style={{
                              width: 'auto',
                              display: 'flex',
                              alignItems: 'flex-start',
                              justifyContent: 'flex-start',
                              flexDirection: 'row',
                              padding: '6px',
                              paddingLeft: '0',
                              marginLeft: '10px',
                            }}
                          >
                            <Tooltip
                              title={isPermanentDeactivate ? 'User is Permanent De-Activate' : 'Permanent De-Activate'}
                            >
                              <Button
                                type="submit"
                                data-toggle="tooltip"
                                data-placement="top"
                                variant={'contained'}
                                onClick={() => {
                                  setpermanentDeactivate({
                                    show: true,
                                    userId: userId,
                                  });
                                }}
                                disabled={isPermanentDeactivate}
                                style={{
                                  width: 50,
                                  minWidth: '50px',
                                  fontSize: '12px',
                                  padding: '6px',
                                  marginRight: '12px',
                                }}
                              >
                                <DoDisturbIcon />
                              </Button>
                            </Tooltip>

                            <Tooltip title={!isActive ? 'Activate' : 'Deactivate'}>
                              <Button
                                variant="contained"
                                color={isActive ? 'primary' : 'error'}
                                onClick={() => {
                                  setActivateModal({
                                    userId,
                                    show: true,
                                    isActive: isActive ? 'true' : 'false',
                                    row,
                                  });
                                }}
                                // onClick={() => {
                                //   activateOrDeactivateUser(isActive, userId);
                                // }}
                                style={{
                                  width: 82,
                                  minWidth: '70px',
                                  fontSize: '12px',
                                }}
                              >
                                {isActive ? 'Activated' : 'Deactivated'}
                              </Button>
                            </Tooltip>
                            <Tooltip title="Notes">
                              <Button
                                type="submit"
                                data-toggle="tooltip"
                                data-placement="top"
                                variant={notes ? '' : 'contained'}
                                onClick={() => {
                                  addnoteToggle(userId);
                                }}
                                style={{
                                  width: 50,
                                  minWidth: '50px',
                                  fontSize: '12px',
                                  padding: '6px',
                                  marginLeft: '8px',
                                }}
                              >
                                <NoteIcon style={{ color: notes && 'rgb(226,204,97)' }}>NoteIcon</NoteIcon>
                              </Button>
                            </Tooltip>
                            <Tooltip title="Edit">
                              <BorderColorIcon
                                style={{
                                  gap: '7px',
                                  marginLeft: '8px',
                                  color: '#fff',
                                  borderRadius: '100px',
                                  width: '30px',
                                  height: '30px',
                                  padding: '6px',
                                  cursor: 'pointer',
                                  background: !isEdit ? '#62b5e5' : '',
                                }}
                                onClick={(event) => {
                                  getUserDetails(userId);
                                  event.stopPropagation();
                                }}
                              >
                                <Iconify
                                  icon="material-symbols:edit"
                                  onClick={(event) => {
                                    getUserDetails(userId);
                                    event.stopPropagation();
                                  }}
                                />
                              </BorderColorIcon>
                            </Tooltip>

                            <Tooltip title="View logs">
                              <Button
                                type="submit"
                                onClick={() =>
                                  navigate(`/dashboard/view-logs?type=user&id=${userId}`, {
                                    state: {
                                      type: 'name',
                                      name: firstName + ' ' + lastName,
                                    },
                                  })
                                }
                                style={{
                                  width: 50,
                                  minWidth: '50px',
                                  fontSize: '12px',
                                  padding: '6px',
                                  marginLeft: '8px',
                                }}
                              >
                                <HistoryIcon />
                              </Button>
                            </Tooltip>
                            <TableCell style={{ fontSize: '13px', padding: '6px', marginLeft: '8px' }}>
                              <DropdownButton
                                id="dropdown-basic-button"
                                title=""
                                className="action-dropdown"
                                style={{ gap: '15px' }}
                              >
                                {!row.isUserUploadedToComplyCube && (
                                  <div
                                    className="invoice_active_hover"
                                    style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}
                                    onClick={() => handleUploadToComplyCube(userId)}
                                  >
                                    <Button style={{ fontSize: '12px' }}>
                                      <CloudUploadIcon style={{ fontSize: '20px' }} />
                                      <p
                                        className="mx-3"
                                        style={{
                                          marginBottom: '0px',
                                          color: 'black',
                                          fontSize: '13px',
                                          fontWeight: 'lighter',
                                        }}
                                      >
                                        Upload to ComplyCube
                                      </p>
                                    </Button>
                                  </div>
                                )}
                              </DropdownButton>
                            </TableCell>
                            {selectedTabValue === '4' && (
                              <TableCell align="left" style={{ padding: '6px' }}>
                              <Tooltip title="Send activation email">
                                <Button
                                  type="submit"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  variant="contained"
                                  onClick={() => {
                                    setisSendLink({
                                      row,
                                      show: true,
                                    });
                                  }}
                                  style={{
                                    width: 50,
                                    minWidth: '50px',
                                    fontSize: '12px',
                                    padding: '6px',
                                    marginLeft: '8px',
                                  }}
                                >
                                  <EmailIcon />
                                </Button>
                              </Tooltip>
                            </TableCell>
                          )}

                            {(invoiceCount === 0 && totalInvoiceAmount === 0) || selectedTabValue === '5' ? (
                              <Tooltip title="Delete User">
                                <Button
                                  variant="contained"
                                  color="error"
                                  onClick={() => {
                                    setDeleteUserModal({ show: true, userId });
                                  }}
                                  style={{
                                    minWidth: '36px',
                                    height: '36px',
                                    borderRadius: '50%',
                                    padding: '4px',
                                    marginLeft: '8px',
                                    boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                                    transition: 'transform 0.2s ease-in-out',
                                  }}
                                  onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                                  onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                >
                                  <DeleteIcon fontSize="small" />
                                </Button>
                              </Tooltip>
                            ) : null}
                          </TableCell>
                        
                        </TableRow>
                      ) : (
                        <PermanentDeactivatedUser
                          userId={userId}
                          row={row}
                          firstName={firstName}
                          lastName={lastName}
                          getUserDetails={getUserDetails}
                          createdDate={createdDate}
                          notes={notes}
                          getUserDetailsInfo={getUserDetailsInfo}
                          setaccidentalReactivate={setaccidentalReactivate}
                          navigate={navigate}
                          deleteUser = {setDeleteUserModal}
                        />
                      )}
                    </>
                  );
                })) ||
                ''}

              <Modal
                open={isOpenModal.sandEmail || false}
                onClose={() => {
                  setIsOpenModal({ sandEmail: false });
                  reset({ emailTemplate: {} });
                  setTemplateData(() => ({
                    content: '<p></p>',
                    Subject: '',
                    templateFromName: '',
                  }));
                  setPersonName([]);
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style} style={{ width: '59%' }}>
                  <Typography id="modal-modal-title" variant="h6" component="h2">
                    Send Email
                  </Typography>

                  <form onSubmit={(e) => handleSendEmail(e)}>
                    <div
                      className="container"
                      style={{
                        overflow: 'auto',
                        height: '450px',
                        width: '105%',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          '& .MuiTextField-root': { width: '75ch' },
                        }}
                      >
                        <FormControl sx={{ mt: 3, mb: 1, width: 735 }}>
                          <InputLabel id="demo-simple-select-required-label">Select E-mail Template</InputLabel>
                          <Select
                            required
                            labelId="demo-simple-select-required-label"
                            id="demo-simple-select-required"
                            label="Select E-mail Template"
                            {...register('emailTemplate.selectedTemplate')}
                          >
                            {emailTemplate?.map((item, index) => {
                              let actieveTemplates = {};
                              const { templateName, id, templateActive } = item;
                              if (templateActive) {
                                actieveTemplates = { templateName, id, item };
                              }
                              return (
                                <MenuItem key={index} value={actieveTemplates.item}>
                                  {actieveTemplates?.templateName}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>

                        <TextField
                          value={templateData.Subject || ''}
                          label={'Subject'}
                          {...register('emailTemplate.templateSubject', {
                            onChange: (e) => {
                              setTemplateData((prevState) => ({
                                ...prevState,
                                Subject: e.target.value,
                              }));
                            },
                          })}
                          id="Subject"
                          margin="normal"
                        />

                        <TextField
                          required
                          value={templateData.templateFromName || ''}
                          label={'Form Name'}
                          {...register('emailTemplate.templateFromName', {
                            onChange: (e) => {
                              setTemplateData((prevState) => ({
                                ...prevState,
                                templateFromName: e.target.value,
                              }));
                            },
                          })}
                          id="Form-Name"
                          margin="normal"
                        />

                        <FormControl sx={{ mt: 2, mb: 2, width: 735 }}>
                          <InputLabel id="demo-multiple-checkbox-label">Send To</InputLabel>
                          <Select
                            multiple
                            value={personName}
                            MenuProps={MenuProps}
                            onChange={handleChange}
                            id="demo-multiple-checkbox"
                            labelId="demo-multiple-checkbox-label"
                            input={<OutlinedInput label="Send To" {...register('emailTemplate.templateReplyTo')} />}
                            renderValue={(selected) => (
                              <Box
                                sx={{
                                  display: 'flex',
                                  flexWrap: 'wrap',
                                  gap: 0.5,
                                }}
                              >
                                {selected?.map((value) => (
                                  <Chip key={value} label={value} />
                                ))}
                              </Box>
                            )}
                          >
                            {filteredUsers?.map((items, index) => {
                              const { email } = items;
                              return (
                                <MenuItem key={index} value={email}>
                                  <Checkbox checked={personName.indexOf(email) > -1} />
                                  <ListItemText primary={email} />
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                        <CKEditor
                          editor={ClassicEditor}
                          data={watch('emailTemplate.selectedTemplate')?.html || '<p></p>'}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            setTemplateData((prevState) => ({
                              ...prevState,
                              content: data,
                            }));
                          }}
                          config={{
                            // extraPlugins: [
                            //   uploadPlugin,
                            //   // Image,
                            //   // ImageResizeEditing,
                            //   // ImageResizeHandles /* ... */,
                            // ],
                            mediaEmbed: {
                              previewsInData: true,
                            },
                            removePlugins: [
                              'Image',
                              'ImageEditing ',
                              'CKFinderEditing',
                              'CKFinder',
                              'ImageCaption',
                              'ImageStyle',
                              'ImageToolbar',
                              'ImageUpload',
                              'EasyImage',
                            ],
                          }}
                        />
                      </Box>
                    </div>

                    <div className="template-buttons">
                      <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel id="demo-select-small-label">Send To</InputLabel>
                        <Select
                          labelId="demo-select-small-label"
                          id="demo-select-small"
                          value={emailType}
                          label="Send To"
                          onChange={handleEmailType}
                        >
                          <MenuItem disabled value="">
                            <em>Send To</em>
                          </MenuItem>
                          <MenuItem value={1}>Send to All Active user</MenuItem>
                          <MenuItem value={2}>Send to All Inactive user</MenuItem>
                          <MenuItem value={3}>Send to All Passive user</MenuItem>
                        </Select>
                      </FormControl>

                      <Button
                        variant="outlined"
                        onClick={() => {
                          reset({ emailTemplate: {} });
                          setIsOpenModal({ sandEmail: false });
                          setTemplateData(() => ({
                            content: '<p></p>',
                            Subject: '',
                            templateFromName: '',
                          }));
                          setPersonName([]);
                        }}
                      >
                        Cancel
                      </Button>

                      <Button style={{ marginLeft: '10px' }} variant="contained" type="submit">
                        Send
                      </Button>
                    </div>
                  </form>
                </Box>
              </Modal>

              <Modal
                open={activateModal.show}
                onClose={() => setActivateModal({ show: false })}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={getModalBoxStyle()}>
                  <Typography id="modal-modal-title" variant="h6" component="h2">
                    Are you sure you want to {activateModal.isActive === 'true' ? 'deactivate' : 'activate'} this user?
                  </Typography>
                  <div
                    style={{
                      margin: '25px 0 0',
                      float: 'right',
                      gap: '10px',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Button
                      onClick={() => setActivateModal({ show: false })}
                      sx={{ float: 'right', backgroundColor: '#62b5e514' }}
                      autoFocus
                    >
                      No
                    </Button>
                    <Button
                      onClick={() => {
                        activateOrDeactivateUser(
                          activateModal.userId,
                          activateModal.isActive === 'true' ? 'false' : 'true',
                          activateModal?.row
                        );
                      }}
                      sx={{ float: 'right', backgroundColor: '#62b5e514' }}
                      autoFocus
                    >
                      Yes
                    </Button>
                  </div>
                </Box>
              </Modal>

              <Modal
                open={permanentDeactivate.show}
                onClose={() => {
                  setpermanentDeactivate({ show: false });
                  setisReasonEmpty(false);
                  setreasonForDeactivated('');
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={getModalBoxStyle()}>
                  <Typography id="modal-modal-title" variant="h6" component="h2">
                    Are you sure you want to permanent deactivate this user?
                  </Typography>
                  <div
                    style={{
                      margin: '25px 0 0',
                      gap: '10px',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <form onSubmit={(e) => handlePermanentDeactivateUser(e, permanentDeactivate?.userId)}>
                      <Form.Group className="modalform" style={{ display: 'flex', alignItems: 'center' }}>
                        <Form.Control
                          as="textarea"
                          placeholder="Reason for permanent deactivating this user"
                          rows={3}
                          style={{
                            resize: 'none',
                            width: '100%',
                            borderRadius: '12px',
                            borderColor: reasonForDeactivated.trim() === '' && isReasonEmpty && '#eb5e5e',
                          }}
                          onChange={(e) => setreasonForDeactivated(e.target.value)}
                          value={reasonForDeactivated}
                        />
                      </Form.Group>
                      <Form.Text
                        style={{
                          fontSize: '14px',
                          color: '#eb5e5e',
                        }}
                      >
                        {reasonForDeactivated.trim() === '' &&
                          isReasonEmpty &&
                          'Please fill in the reason for deactivating this user'}
                      </Form.Text>
                      <div className="mt-2">
                        <Button type="submit" sx={{ float: 'right', backgroundColor: '#62b5e514' }} autoFocus>
                          Yes
                        </Button>

                        <Button
                          onClick={() => {
                            setpermanentDeactivate({ show: false });
                            setisReasonEmpty(false);
                            setreasonForDeactivated('');
                          }}
                          sx={{
                            float: 'right',
                            marginRight: '15px',
                            backgroundColor: '#62b5e514',
                          }}
                          autoFocus
                        >
                          No
                        </Button>
                      </div>
                    </form>
                  </div>
                </Box>
              </Modal>

              <Modal
                open={accidentalReactivate.show}
                onClose={() => {
                  setaccidentalReactivate({ show: false });
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={getModalBoxStyle()}>
                  <Typography id="modal-modal-title" variant="h6" component="h2">
                    Are you sure you want to re-activate this user?
                  </Typography>
                  <div className="mt-4">
                    <Button
                      onClick={handleChangeStatusOfDeactivate}
                      type="submit"
                      sx={{ float: 'right', backgroundColor: '#62b5e514' }}
                      autoFocus
                    >
                      Yes
                    </Button>
                    <Button
                      onClick={() => {
                        setaccidentalReactivate({ show: false });
                      }}
                      sx={{
                        float: 'right',
                        marginRight: '15px',
                        backgroundColor: '#62b5e514',
                      }}
                      autoFocus
                    >
                      No
                    </Button>
                  </div>
                </Box>
              </Modal>

              <Modal
                open={deleteUserModal.show}
                onClose={() => setDeleteUserModal({ show: false, userId: null })}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={getModalBoxStyle()}>
                  <Typography id="modal-modal-title" variant="h6" component="h2">
                    Are you sure you want to permanently delete this user?
                  </Typography>
                  <div className="mt-4">
                    <Button
                      onClick={() => {
                        handleDeleteUser(deleteUserModal.userId);
                      }}
                      type="submit"
                      sx={{ float: 'right', backgroundColor: '#e57373', color: '#fff', '&:hover': { backgroundColor: '#d32f2f' } }}
                      autoFocus
                    >
                      Yes
                    </Button>
                    <Button
                      onClick={() => setDeleteUserModal({ show: false, userId: null })}
                      sx={{
                        float: 'right',
                        marginRight: '15px',
                        backgroundColor: '#cfd8dc',
                        color: '#000',
                      }}
                    >
                      No
                    </Button>
                  </div>
                </Box>
              </Modal>

              {/* SSN Verification Modal */}
              <SSNVerificationModal
                open={ssnVerificationModal.show}
                onClose={() => setSsnVerificationModal({ show: false, expectedData: null, sparData: null, reason: '', status: '', userId: null, ssn: null, isSsnValid: null, isPending: false })}
                verificationData={ssnVerificationModal}
                onManualVerification={(userId) => handleManualSSNVerification(userId)}
                loading={loading}
                onVerificationComplete={() => {
                  fetchUsers();
                }}
              />

            </TableBody>
            {isNotFound && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={12} sx={{ py: 3 }}>
                    <SearchNotFound searchQuery={searchQuery} />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Scrollbar>

      <Modal
        open={isOpenModal.bankDetails || false}
        onClose={() => setIsOpenModal({ bankDetails: false })}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={getModalBoxStyle()}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Bank Details
          </Typography>
          <form
            onSubmit={handleSubmitForm2((values) => {
              editBankDetails(values.bankDetails);
            })}
          >
            <div className="edit-bank-details">
              <TableRow>
                <TableCell align="left" colSpan={6} sx={{ py: 3, fontWeight: 'bold', mr: 1 }}>
                  Banks
                </TableCell>
                <TableCell align="left" colSpan={6} sx={{ py: 3 }}>
                  <Select
                    sx={{ mt: 2, mb: 2, width: '100%' }}
                    variant="standard"
                    id="chooseBankName"
                    value={chooseBankName || ''}
                    label="Bank"
                    {...registerForm2('bankDetails.chooseBankName')}
                    onChange={handleBankChange}
                  >
                    {banksData &&
                      banksData?.length > 0 &&
                      banksData?.map((bankData, index) => (
                        <MenuItem key={index} value={bankData.description}>
                          {bankData.description}
                        </MenuItem>
                      ))}
                  </Select>
                </TableCell>
              </TableRow>

              {chooseBankName === 'Foreign bank BIC/IBAN' || chooseBankName === 'Foreign bank BIC / IBAN' || chooseBankName === 'Revolut Bank' ? (
                <>
                  <TableRow>
                    <TableCell align="left" colSpan={6} sx={{ py: 3, fontWeight: 'bold' }}>
                      IBAN Number
                    </TableCell>
                    <TableCell align="left" colSpan={6} sx={{ py: 3 }}>
                      <TextField
                        id="ibanNumber"
                        {...registerForm2('bankDetails.ibanNumber', {
                          required: true,
                        })}
                        variant="standard"
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left" colSpan={6} sx={{ py: 3, fontWeight: 'bold' }}>
                      BIC Number
                    </TableCell>
                    <TableCell align="left" colSpan={6} sx={{ py: 3 }}>
                      <TextField
                        id="bicNumber"
                        {...registerForm2('bankDetails.bicNumber', {
                          required: true,
                        })}
                        variant="standard"
                      />
                    </TableCell>
                  </TableRow>
                </>
              ) : null}

              {!(chooseBankName === 'Foreign bank BIC / IBAN' || chooseBankName === 'Foreign bank BIC/IBAN' || chooseBankName === 'Revolut Bank') ? (
                <>
                  {chooseBankName === 'Other banks' && (
                    <TableRow>
                      <TableCell align="left" colSpan={6} sx={{ py: 3, fontWeight: 'bold' }}>
                        Bank Name
                      </TableCell>
                      <TableCell align="left" colSpan={6} sx={{ py: 3 }}>
                        <TextField
                          id="createBankName"
                          {...registerForm2('bankDetails.createBankName')}
                          variant="standard"
                        />
                      </TableCell>
                    </TableRow>
                  )}
                  <TableRow>
                    <TableCell align="left" colSpan={6} sx={{ py: 3, fontWeight: 'bold' }}>
                      Clearing Number
                    </TableCell>
                    <TableCell align="left" colSpan={6} sx={{ py: 3 }}>
                      <TextField
                        id="clearingNumber"
                        {...registerForm2('bankDetails.clearingNumber')}
                        variant="standard"
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left" colSpan={6} sx={{ py: 3, fontWeight: 'bold' }}>
                      Account number
                    </TableCell>
                    <TableCell align="left" colSpan={6} sx={{ py: 3 }}>
                      <TextField
                        id="accountNumber"
                        {...registerForm2('bankDetails.accountNumber')}
                        variant="standard"
                      />
                    </TableCell>
                  </TableRow>

                  {Object.keys(selectedUser)?.length > 0 && selectedUser?.customerSalaryInformation?.length > 0 && (
                    <TableRow>
                      <TableCell align="left" colSpan={6} sx={{ py: 3, fontWeight: 'bold' }}>
                        Created Date
                      </TableCell>
                      <TableCell align="left" colSpan={6} sx={{ py: 3 }}>
                        {selectedUser?.customerSalaryInformation[0]?.createdDate
                          ? new Date(selectedUser.customerSalaryInformation[0]?.createdDate).toISOString().split('T')[0]
                          : ''}
                      </TableCell>
                    </TableRow>
                  )}
                </>
              ) : null}
            </div>

            <Button style={{ marginLeft: '10px' }} variant="contained" type="submit">
              Save Changes
            </Button>

            <Button
              onClick={() => {
                resetForm2({ bankDetails: {} });
                setBankName(
                  Object.keys(selectedUser)?.length > 0 ? selectedUser.customerSalaryInformation[0]?.bank : ''
                );
                setChooseBankName(banksData.some((item) => item.description === bankName) ? bankName : 'Other banks');
                setIsOpenModal({ bankDetails: false });
              }}
              sx={{ float: 'right' }}
              autoFocus
            >
              Close
            </Button>
          </form>
        </Box>
      </Modal>

      {/* Add Notes  Modal */}
      <Modal
        open={toggleNote}
        onClose={() => {
          setToggleNote(false);
          setNotesContent('');
          setIsNotesContentEmpty(false);
           setNoteType('General');
            setSurveyNotes([]);
            setSurveyRatings({});
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={commentStyle} style={{ overflowY: 'auto' }}>
          <Box sx={{ height: 'fit-content' }} id="usersList-modal">
            <IconButton
              color="inherit"
              onClick={() => {
                setToggleNote(false);
                setNotesContent('');
                setIsNotesContentEmpty(false);
                 setNoteType('General');
                  setSurveyNotes([]);
                  setSurveyRatings({});
              }}
              sx={{
                position: 'absolute',
                right: 5,
                top: 0,
              }}
              aria-label="close"
            >
              <ClearIcon style={{ fontSize: 26 }} />
            </IconButton>
            <Typography id="modal-modal-title" variant="h6" component="h2" style={{ width: '100%' }}>
              Notes
            </Typography>

            {viewSurveyAnswers ? (
              <>
                <Button
                  variant="outlined"
                  size="small"
                  style={{ margin: '10px 0 15px 0' }}
                  onClick={() => {
                    setViewSurveyAnswers(false);
                    setSurveyAnswers([]);
                  }}
                >
                  Back
                </Button>
                <div style={{ marginTop: 10 }}>
                  {surveyAnswersLoading ? (
                    <div style={{ fontSize: 14, color: '#888' }}>Loading...</div>
                  ) : surveyAnswers.length === 0 ? (
                    <div style={{ fontSize: 14, color: '#888', textAlign: 'center', marginBottom: 8 }}>
                      No survey answers found.
                    </div>
                  ) : (
                    <div style={{ width: '100%', display: 'flex', flexWrap: 'wrap', gap: isMobile ? 8 : 16 }}>
                      {surveyAnswers.map((ans, idx) => (
                        <div
                          key={idx}
                          className="survey-card"
                          style={{
                            flex: isMobile ? '1 1 100%' : '1 1 38%',
                            minWidth: isMobile ? '90vw' : 240,
                            maxWidth: isMobile ? '98vw' : 320,
                            marginBottom: isMobile ? 8 : 16,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            padding: isMobile ? 10 : 14,
                            borderRadius: 10,
                            background: 'linear-gradient(135deg, #f9f9f9 60%, #e3f2fd 100%)',
                            boxShadow: '0 1px 6px rgba(0,0,0,0.06)',
                            minHeight: 80,
                            border: '1px solid #e0e0e0',
                            position: 'relative',
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            style={{
                              marginBottom: 6,
                              fontWeight: 600,
                              color: '#1976d2',
                              fontSize: isMobile ? 13 : 15,
                              lineHeight: 1.3,
                            }}
                          >
                            {ans.surveyQuestion || ans.customQuestion || 'Question'}
                          </Typography>
                          {ans.answer && !ans.customQuestion ? (
                            <div style={{ display: 'flex', alignItems: 'center', marginTop: 2 }}>
                              {[1, 2, 3, 4, 5].map((star) => (
                                <span
                                  key={star}
                                  style={{
                                    color: star <= Number(ans.answer) ? '#FFD700' : '#e0e0e0',
                                    fontSize: isMobile ? 20 : 22,
                                    marginRight: 2,
                                    filter: 'drop-shadow(0 1px 2px #eee)',
                                    userSelect: 'none',
                                  }}
                                >
                                  ★
                                </span>
                              ))}
                              <span style={{ marginLeft: 8, color: '#888', fontSize: isMobile ? 12 : 13 }}>
                                ({ans.answer} / 5)
                              </span>
                            </div>
                          ) : ans.customQuestion ? (
                            <div style={{ marginTop: 2, color: '#333', fontSize: isMobile ? 14 : 15, display: 'flex', alignItems: 'center' }}>
                             <span style={{ marginLeft: 6, display: 'flex', alignItems: 'center' }}>
                                {[1, 2, 3, 4, 5].map((star) => (
                                  <span
                                    key={star}
                                    style={{
                                      color: star <= Number(ans.customAnswer) ? '#FFD700' : '#e0e0e0',
                                      fontSize: isMobile ? 20 : 22,
                                      marginRight: 2,
                                      filter: 'drop-shadow(0 1px 2px #eee)',
                                      userSelect: 'none',
                                    }}
                                  >
                                    ★
                                  </span>
                                ))}
                                <span style={{ marginLeft: 8, color: '#888', fontSize: isMobile ? 12 : 13 }}>
                                  ({ans.customAnswer || '-'} / 5)
                                </span>
                              </span>
                            </div>
                          ) : (
                            <div style={{ marginTop: 2, color: '#888', fontSize: isMobile ? 13 : 14 }}>
                              No answer
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </>
            ) : (
              <>
              <FormControl
                                variant="outlined"
                                size="small"
                                style={{
                                  minWidth: 180,
                                  marginTop: "20px",
                                  background: "#fff",
                                  borderRadius: 8,
                                  border: "1px solid #e0e0e0",
                                  boxShadow: "none",
                                  padding: 2,
                                }}
                              >
                              <InputLabel
                               id="note-type-label"
                               style={{
                                 color: '#1976d2',
                                 fontWeight: 500,
                                 fontSize: 15,
                                 letterSpacing: 0.2,
                               }}
                             >
                               Type
                             </InputLabel>
                              <Select
                                labelId="note-type-label"
                                value={noteType}
                                label="Type"
                                onChange={async (e) => {
                                  const val = e.target.value;
                                  setNoteType(val);
                                  if (val === 'Survey') {
                                    setSurveyLoading(true);
                                    try {
                                      // Only fetch default questions, do not check for existing answers
                                      const qRes = await axios.get('/adminNotesSurvey/get-survey-question?surveyType=5');
                                      let notes = (qRes.data?.response || []).map(q => ({
                                        surveyQuestionId: q.surveyQuestionId,
                                        surveyQuestion: q.question,
                                        surveyType: q.surveyType,
                                        answer: null, // No answer yet
                                        isCustom: false,
                                      }));
                                      setSurveyNotes(notes);
                                      setSurveySubmitted(false);
                                      setSurveyRatings({});
                                      setCustomQuestion('');
                                      setCustomRating(0);
                                    } catch {
                                      setSurveyNotes([]);
                                      setSurveySubmitted(false);
                                    } finally {
                                      setSurveyLoading(false);
                                    }
                                  } else {
                                    setSurveySubmitted(false);
                                  }
                                }}
                               sx={{
                                   background: "#fff",
                                   borderRadius: 2,
                                   fontWeight: 500,
                                   color: "#1976d2",
                                   fontSize: 15,
                                   transition: "border-color 0.2s",
                                   "&:hover": {
                                     borderColor: "#1976d2",
                                   },
                                   boxShadow: "none",
                                 }}
                                 MenuProps={{
                                   PaperProps: {
                                     sx: {
                                       borderRadius: 2,
                                       boxShadow: "0 2px 8px #1976d220",
                                     },
                                   },
                                 }}
                              >
                                <MenuItem value="General">General</MenuItem>
                                <MenuItem value="Survey">Survey</MenuItem>
                                <MenuItem value="Economic">Economic</MenuItem>
                              </Select>
                            </FormControl>
                           {noteType === 'Survey' && (
                                          <div style={{ marginTop: 10 }}>
                                            {surveyLoading ? (
                                              <div style={{ fontSize: 14, color: '#888' }}>Loading...</div>
                                            ) : surveySubmitted ? (
                                              <div style={{ fontSize: 15, color: '#1976d2', textAlign: 'center', marginBottom: 8 }}>
                                                Survey answers submitted!
                                              </div>
                                            ) : (
                                              <>
                                                {surveyNotes.length === 0 && (
                                                  <div style={{ fontSize: 14, color: '#888', textAlign: 'center', marginBottom: 8 }}>
                                                    No survey questions found.
                                                  </div>
                                                )}
                                                <div
                                                  style={{
                                                    width: '100%',
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    gap: isMobile ? 8 : 16,
                                                    justifyContent: isMobile ? 'center' : 'flex-start',
                                                  }}
                                                >
                                                  {surveyNotes.map((q, idx) => (
                                                    <div
                                                      key={q.surveyQuestionId || `custom-${idx}`}
                                                      className="survey-card"
                                                      style={{
                                                        flex: isMobile ? '1 1 100%' : '1 1 38%',
                                                        minWidth: isMobile ? '90vw' : 240,
                                                        maxWidth: isMobile ? '98vw' : 320,
                                                        marginBottom: isMobile ? 8 : 16,
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'flex-start',
                                                        padding: isMobile ? 10 : 14,
                                                        borderRadius: 10,
                                                        background: 'linear-gradient(135deg, #f9f9f9  60%, #e3f2fd 100%)',
                                                        boxShadow: '0 1px 6px rgba(0,0,0,0.06)',
                                                        minHeight: 80,
                                                        border: '1px solid #e0e0e0',
                                                        position: 'relative',
                                                      }}
                                                    >
                                                      <Typography
                                                        variant="subtitle2"
                                                        style={{
                                                          marginBottom: 6,
                                                          fontWeight: 600,
                                                          color: '#1976d2',
                                                          fontSize: isMobile ? 13 : 15,
                                                          lineHeight: 1.3,
                                                        }}
                                                      >
                                                        {q.surveyQuestion || q.customQuestion || 'Question'}
                                                      </Typography>
                                                      <div style={{ display: 'flex', alignItems: 'center', marginTop: 2 }}>
                                                        {[1, 2, 3, 4, 5].map((star) => (
                                                          <span
                                                            key={star}
                                                            style={{
                                                              cursor: !q.answer ? 'pointer' : 'default',
                                                              color:
                                                                (q.answer
                                                                  ? star <= Number(q.answer)
                                                                  : star <= (surveyRatings[q.surveyQuestionId] || 0))
                                                                  ? '#FFD700'
                                                                  : '#e0e0e0',
                                                              fontSize: isMobile ? 20 : 22,
                                                              marginRight: 2,
                                                              transition: 'color 0.2s, transform 0.1s',
                                                              filter: 'drop-shadow(0 1px 2px #eee)',
                                                              userSelect: 'none',
                                                            }}
                                                            onClick={() => {
                                                              if (!q.answer) {
                                                                setSurveyRatings((prev) => ({
                                                                  ...prev,
                                                                  [q.surveyQuestionId]: star,
                                                                }));
                                                              }
                                                            }}
                                                            title={star + ' Star'}
                                                          >
                                                            ★
                                                          </span>
                                                        ))}
                                                        {q.answer && (
                                                          <span style={{ marginLeft: 8, color: '#888', fontSize: isMobile ? 12 : 13 }}>
                                                            ({q.answer} / 5)
                                                          </span>
                                                        )}
                                                      </div>
                                                    </div>
                                                  ))}
                                                  {/* Custom Question UI */}
                                                  <div
                                                    className="survey-card"
                                                    style={{
                                                      flex: isMobile ? '1 1 100%' : '1 1 38%',
                                                      minWidth: isMobile ? '90vw' : 240,
                                                      maxWidth: isMobile ? '98vw' : 320,
                                                      marginBottom: isMobile ? 8 : 16,
                                                      display: 'flex',
                                                      flexDirection: 'column',
                                                      alignItems: 'flex-start',
                                                      padding: isMobile ? 10 : 14,
                                                      borderRadius: 10,
                                                      background: 'linear-gradient(135deg, #f9f9f9 60%, #e3f2fd 100%)',
                                                      boxShadow: '0 1px 6px rgba(0,0,0,0.06)',
                                                      minHeight: 80,
                                                      border: '1px solid #e0e0e0',
                                                      position: 'relative',
                                                    }}
                                                  >
                                                    <Typography
                                                      variant="subtitle2"
                                                      style={{
                                                        marginBottom: 6,
                                                        fontWeight: 600,
                                                        color: '#1976d2',
                                                        fontSize: isMobile ? 13 : 15,
                                                        lineHeight: 1.3,
                                                      }}
                                                    >
                                                      Custom Question
                                                    </Typography>
                                                    <input
                                                      type="text"
                                                      placeholder="Enter your custom question"
                                                      value={customQuestion || ''}
                                                      onChange={e => setCustomQuestion(e.target.value)}
                                                      style={{
                                                        width: '100%',
                                                        marginBottom: 6,
                                                        padding: 6,
                                                        borderRadius: 6,
                                                        border: '1px solid #ccc',
                                                        fontSize: 14,
                                                      }}
                                                    />
                                                    <div style={{ display: 'flex', alignItems: 'center', marginTop: 2 }}>
                                                      {[1, 2, 3, 4, 5].map((star) => (
                                                        <span
                                                          key={star}
                                                          style={{
                                                            cursor: 'pointer',
                                                            color: star <= customRating ? '#FFD700' : '#e0e0e0',
                                                            fontSize: isMobile ? 20 : 22,
                                                            marginRight: 2,
                                                            transition: 'color 0.2s, transform 0.1s',
                                                            filter: 'drop-shadow(0 1px 2px #eee)',
                                                            userSelect: 'none',
                                                          }}
                                                          onClick={() => setCustomRating(star)}
                                                          title={star + ' Star'}
                                                        >
                                                          ★
                                                        </span>
                                                      ))}
                                                      {customRating > 0 && (
                                                        <span style={{ marginLeft: 8, color: '#888', fontSize: isMobile ? 12 : 13 }}>
                                                          ({customRating} / 5)
                                                        </span>
                                                      )}
                                                    </div>
                                                  </div>
                                                </div>
                                                {!surveySubmitted && (
                                                  <div style={{ textAlign: isMobile ? 'center' : 'right', marginTop: 10 }}>
                                                    <Button
                                                     variant="contained"
                                                      size="small"
                                                      style={{
                                                        minWidth: 90,
                                                        fontWeight: 600,
                                                        fontSize: isMobile ? 13 : 13,
                                                        borderRadius: 6,
                                                        boxShadow: '0 1px 6px #1976d220',
                                                        // background: 'linear-gradient(90deg, #1976d2 60%, #64b5f6 100%)',
                                                        color: '#fff',
                                                        letterSpacing: 0.5,
                                                        padding: '4px 16px',
                                                        opacity: surveyNotes.length > 0 && surveyNotes.every((q) => surveyRatings[q.surveyQuestionId] > 0) ? 1 : 0.6,
                                                        pointerEvents: surveyNotes.length > 0 && surveyNotes.every((q) => surveyRatings[q.surveyQuestionId] > 0) ? 'auto' : 'none',
                                                      }}
                                                      disabled={surveyNotes.length === 0 || !surveyNotes.every((q) => surveyRatings[q.surveyQuestionId] > 0)}
                                                      onClick={async () => {
                                                        const NotesSurvey = [
                                                          ...surveyNotes.map((q) => ({
                                                            SurveyQuestionId: q.surveyQuestionId,
                                                            Answer: String(surveyRatings[q.surveyQuestionId] || 0),
                                                            CustomQuestion: "",
                                                            CustomAnswer: ""
                                                          })),
                                                          ...(customQuestion && customRating > 0
                                                            ? [{
                                                                SurveyQuestionId: null,
                                                                Answer: "",
                                                                CustomQuestion: customQuestion,
                                                                CustomAnswer: String(customRating),
                                                              }]
                                                            : [])
                                                        ];
                          
                                                        if (NotesSurvey.length === 0) return;
                          
                                                        setSurveyLoading(true);
                          
                                                        try {
                                                          const InvoiceNumber = 0; // Replace with actual invoice number if available
                          
                                                          const payload = {
                                                            CustomerId: 0,
                                                            userId: selectedUserId,
                                                            InvoiceNumber,
                                                            NotesType: 5,
                                                            NotesSurvey,
                                                            Description: '',
                                                          };
                          
                                                          await axios.post('/adminNotesSurvey/add-survey-response', payload);
                          
                                                         const qRes = await axios.get('/adminNotesSurvey/get-survey-question?surveyType=5');
                                                          let notes = (qRes.data?.response || []).map(q => ({
                                                            surveyQuestionId: q.surveyQuestionId,
                                                            surveyQuestion: q.question,
                                                            surveyType: q.surveyType,
                                                            answer: null,
                                                            isCustom: false,
                                                          }));
                                                          setSurveyNotes(notes);
                                                          setSurveyRatings({});
                                                          setCustomQuestion('');
                                                          setCustomRating(0);
                                                          setSurveySubmitted(false); // Do not show "Survey answers submitted!"
                                                          setSurveyReloaded(false);
                                                          fetchCommentList();
                                                          fetchUsers();
                                                          toast.success('Survey answers submitted!');
                                                        } catch (err) {
                                                          // toast.error('Failed to submit survey answers');
                                                        } finally {
                                                          setSurveyLoading(false); 
                                                        }
                                                      }}
                                                    >
                                                      {surveyLoading ? 'Submitting...' : 'Submit'}
                                                    </Button>
                                                  </div>
                                                )}
                                              </>
                                            )}
                                          </div>
                                        )}
            
            <>
             {(noteType === 'General' || noteType === 'Economic') && (
            <Form>
              <Form.Group
                className="modalform"
                style={{
                  marginTop: '20px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Form.Control
                  as="textarea"
                  rows={3}
                  style={{
                    resize: 'none',
                    width: '50%',
                    borderRadius: '12px',
                    borderColor: isNotesContentEmpty && '#eb5e5e',
                  }}
                  onChange={(e) => setNotesContent(e.target.value)}
                  value={notesContent}
                />
                <Button variant="contained" style={{ height: '40px', marginLeft: '20px' }} onClick={postAddnotes}>
                  <AddCircleIcon />
                </Button>
              </Form.Group>
            </Form>)}
            </>
            <div style={{ height: '250px', overflow: 'auto', marginTop: '10px' }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Date </TableCell>
                    <TableCell>Notes Type </TableCell>
                    <TableCell>Message</TableCell>
                    <TableCell>Added By</TableCell>
                  </TableRow>
                </TableHead>
                {loading ? (
                  ''
                ) : (
                  <TableBody>
                    {commentList?.length > 0 ? (
                      commentList?.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell> {formatDate(row?.createdDate)}</TableCell>
                           <TableCell>
                        {row?.noteType === 1 ? "General" : row?.noteType === 5 ? "Survey" : row?.noteType === 7 ? "Economic" : row?.noteType === 4 ? "Invoice" : "Unknown"}
                        </TableCell>
                        {(row?.noteType === 1 || row?.noteType === 4) ?
                          <TableCell>
                            {row?.description?.length > 30 ? (
                              <TooltipWithCopy text={row?.description} />
                            ) : (
                              row?.description
                            )}
                          </TableCell> : row?.noteType === 5 ?
                          <TableCell>
                            <Button
                              style={{ marginLeft: '10px' }}
                              variant="contained"
                              onClick={async () => {
                                setSurveyAnswersLoading(true);
                                setViewSurveyAnswers(true);
                                try {
                                  const res = await axios.get(`/AdminNotesSurvey/user-customer-survey-notes?noteId=${row.id}`);
                                  setSurveyAnswers(res.data?.response || []);
                                } catch {
                                  setSurveyAnswers([]);
                                } finally {
                                  setSurveyAnswersLoading(false);
                                }
                              }}
                            >
                              View
                            </Button>
                          </TableCell> : row?.noteType === 7 ? <TableCell>
                            {row?.description?.length > 30 ? (
                              <TooltipWithCopy text={row?.description} />
                            ) : (
                              row?.description
                            )}
                          </TableCell> : "Unknown"}
                          <TableCell> {row?.addedBy} </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow className="text-center">
                        <TableCell colSpan={2} style={{ textAlign: 'center' }}>
                          No record found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                )}
              </Table>
            </div>
            </>)}
       </Box>
       </Box>
      
        
      </Modal>

      <Modal
        open={showEditModal || false}
        onClose={() => {
          setShowEditModal(false);
          setShowUserDetails(null);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={boxStyle}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Edit User Details
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <form
              onSubmit={handleSubmit((values) => {
                editUserDetails(values);
              })}
            >
              <div className="container" style={{ overflow: 'auto', height: '450px', width: '105%' }}>
                <Box
                  sx={{
                    display: 'flex',
                    marginTop: '9px',
                    flexDirection: 'column',
                    '& .MuiTextField-root': { width: '25ch' },
                  }}
                >
                  <Autocomplete
                    freeSolo
                    value={watch('userAccountType')}
                    id="combo-box-demo"
                    options={[
                      { label: 'Private Account' },
                      { label: 'Business Account' },
                      // { label: 'Business Construction' },
                    ]}
                    sx={{ width: 300, marginTop: '12px' }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        style={{ marginBottom: '10px' }}
                        label={'Account Type'}
                        id="margin-dense"
                        {...register('userAccountType', {
                          required: true,
                        })}
                        onKeyDown={(e) => {
                          const inputValue = e.key;
                         const allowedCharacters = /^[0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]$/;

                          if (inputValue !== 'Backspace' && !allowedCharacters.test(inputValue)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    )}
                  />

                  <TextField
                    error={errors.firstName}
                    label={'First Name'}
                    {...register('firstName', {
                      required: true,
                    })}
                    id="margin-dense"
                  />
                  <TextField label={'Last Name'} {...register('lastName')} id="margin-normal" margin="normal" />
                  <TextField
                    label={'Phone No.'}
                    error={errors?.phoneNo}
                    {...register('phoneNo', {
                      required: true,
                    })}
                    id="margin-normal"
                    margin="normal"
                    onKeyDown={(e) => {
                      if (
                            (e.ctrlKey || e.metaKey) &&
                            ['c', 'v', 'x', 'a'].includes(e.key.toLowerCase())
                          ) {
                            return;
                          }
                      const inputValue = e.key;
                      const allowedCharacters = /^[0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]$/;

                        if (inputValue !== 'Backspace' && !allowedCharacters.test(inputValue)) {
                        e.preventDefault();
                      }
                    }}
                  />
                  <TextField
                    type="email"
                    error={errors?.email}
                    label={'Email'}
                    {...register('email', {
                      required: true,
                    })}
                    id="margin-dense"
                    margin="normal"
                  />
                  <TextField label={'Address'} {...register('address')} id="margin-normal" margin="normal" />
                  <TextField
                    label={'City'}
                    {...register('city')}
                    id="margin-dense"
                    margin="normal"
                    onKeyDown={(e) => {
                      if (
                            (e.ctrlKey || e.metaKey) &&
                            ['c', 'v', 'x', 'a'].includes(e.key.toLowerCase())
                          ) {
                            return;
                          }
                      const inputValue = e.key;
                      // This regular expression allows any character except digits (0-9)
                      const disallowedCharacters = /^[0-9]$/;

                      if (inputValue !== 'Backspace' && disallowedCharacters.test(inputValue)) {
                        e.preventDefault();
                      }
                    }}
                  />
                  <TextField
                    label={'Profession'}
                    {...register('profession')}
                    id="margin-normal"
                    margin="normal"
                    onKeyDown={(e) => {
                      if (
                            (e.ctrlKey || e.metaKey) &&
                            ['c', 'v', 'x', 'a'].includes(e.key.toLowerCase())
                          ) {
                            return;
                          }
                      const inputValue = e.key;
                      // This regular expression allows any character except digits (0-9)
                      const disallowedCharacters = /^[0-9]$/;

                      if (inputValue !== 'Backspace' && disallowedCharacters.test(inputValue)) {
                        e.preventDefault();
                      }
                    }}
                  />
                  <Autocomplete
                    freeSolo
                    value={watch('country')}
                    id="combo-box-demo"
                    options={newDetails}
                    sx={{ width: 300, marginTop: '12px' }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={errors?.country}
                        {...register('country', {
                          required: true,
                        })}
                        label="Country"
                      />
                    )}
                    onKeyDown={(e) => {
                      const inputValue = e.key;
                      // This regular expression allows any character except digits (0-9)
                      const disallowedCharacters = /^[0-9]$/;
                      if (inputValue !== 'Backspace' && disallowedCharacters.test(inputValue)) {
                        e.preventDefault();
                      }
                    }}
                  />

                  <FormControl className="mt-2" sx={{ width: 248, marginTop: '12px' }}>
                    <InputLabel id="demo-simple-select-label">DOB/SSN</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={selectedOption}
                      onChange={handleSelectChange}
                      label="DOB/SSN"
                    >
                      <MenuItem value="DOB">DOB</MenuItem>
                      <MenuItem value="SSN">SSN</MenuItem>
                    </Select>
                  </FormControl>

                  {selectedOption === 'SSN' ? (
                    <>
                      <TextField
                        error={errors?.ssn}
                        label={'SSN No.'}
                        {...register('ssn', {
                          required: true,
                          minLength: 12,
                           validate: (value) => {
                            if (value.length === 12 && value.slice(-4) === '0000') {
                              return 'Last 4 digits cannot be 0000';
                            }
                            return true;
                          },
                        })}
                        id="margin-dense"
                        margin="normal"
                        onKeyDown={(e) => {
                          if (
                            (e.ctrlKey || e.metaKey) &&
                            ['c', 'v', 'x', 'a'].includes(e.key.toLowerCase())
                          ) {
                            return;
                          }
                          const inputValue = e.key;
                           const allowedCharacters = /^[0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]$/;

                          if (inputValue !== 'Backspace' && !allowedCharacters.test(inputValue)) {
                            e.preventDefault();
                          }
                        }}
                        onInput={(e) => {
                          const maxLength = 12;
                          e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, '');

                          if (e.target.value.length > maxLength) {
                            e.target.value = e.target.value.slice(0, maxLength);
                          }
                        }}
                      />
                      {errors?.ssn?.message && (
                        <p
                          style={{
                            fontSize: '11px',
                            color: 'pink',
                            padding: '0 14px',
                          }}
                        >
                          {errors.ssn.message}
                        </p>
                      )}
                      {ssnNumber?.length < 12 && !errors?.ssn?.message ? (
                        <p
                          style={{
                            fontSize: '11px',
                            color: 'red',
                            padding: '0 14px',
                          }}
                        >
                          SSN number must have 12 digits
                        </p>
                      ) : (
                        ''
                      )}
                    </>
                  ) : (
                    <TextField
                      label={'DOB'}
                      error={errors?.dateOfBirth}
                      {...register('dateOfBirth', {
                        required: true,
                      })}
                      id="margin-dense"
                      margin="normal"
                      onKeyDown={(e) => {
                        if (
                            (e.ctrlKey || e.metaKey) &&
                            ['c', 'v', 'x', 'a'].includes(e.key.toLowerCase())
                          ) {
                            return;
                          }
                        const inputValue = e.key;
                         const allowedCharacters = /^[0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]$/;

                        if (inputValue !== 'Backspace' && !allowedCharacters.test(inputValue)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  )}
                  <TextField
                    label={'Postal Code'}
                    {...register('zipCode')}
                    id="margin-dense"
                    margin="normal"
                    onKeyDown={(e) => {
                      if (
                            (e.ctrlKey || e.metaKey) &&
                            ['c', 'v', 'x', 'a'].includes(e.key.toLowerCase())
                          ) {
                            return;
                          }
                      const inputValue = e.key;
                      const allowedCharacters = /^[0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]$/;

                        if (inputValue !== 'Backspace' && !allowedCharacters.test(inputValue)) {
                        e.preventDefault();
                      }
                    }}
                  />
                  <TextField label={'C/O'} {...register('organisation')} id="margin-normal" margin="normal" />
                  <TextField
                    label={'Income Tax'}
                    {...register('incomeTax')}
                    id="margin-normal"
                    margin="normal"
                    onKeyDown={(e) => {
                      if (
                            (e.ctrlKey || e.metaKey) &&
                            ['c', 'v', 'x', 'a'].includes(e.key.toLowerCase())
                          ) {
                            return;
                          }
                      const inputValue = e.key;
                      const allowedCharacters = /^[0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]$/;

                        if (inputValue !== 'Backspace' && !allowedCharacters.test(inputValue)) {
                        e.preventDefault();
                      }
                    }}
                  />
                  <TextField
                    label={'Invozio Fee'}
                    {...register('fakturaFee')}
                    id="margin-dense"
                    margin="normal"
                    onKeyDown={(e) => {
                      if (
                            (e.ctrlKey || e.metaKey) &&
                            ['c', 'v', 'x', 'a'].includes(e.key.toLowerCase())
                          ) {
                            return;
                          }
                      const inputValue = e.key;
                      const allowedCharacters = /^[0-9!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]$/;

                        if (inputValue !== 'Backspace' && !allowedCharacters.test(inputValue)) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Box>
              </div>

              <Button
                variant="contained"
                onClick={() => {
                  setShowEditModal(false);
                  setShowUserDetails(null);
                }}
              >
                Close
              </Button>
              <Button style={{ marginLeft: '10px' }} variant="contained" type="submit">
                Save Changes
              </Button>
            </form>
          </Typography>
        </Box>
      </Modal>

      <Modal
        open={isSendLink.show}
        onClose={() => setisSendLink({ show: false })}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={getModalBoxStyle()}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {'Are you sure you want to resend account activation email?'}
          </Typography>
          <div
            style={{
              margin: '25px 0 0',
              float: 'right',
              gap: '10px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Button
              onClick={() => setisSendLink({ show: false })}
              sx={{ float: 'right', backgroundColor: '#62b5e514' }}
              autoFocus
            >
              No
            </Button>
            <Button
              onClick={() => {
                handleSendLink(isSendLink);
              }}
              sx={{ float: 'right', backgroundColor: '#62b5e514' }}
              autoFocus
            >
              Yes
            </Button>
          </div>
        </Box>
      </Modal>

      {/* get Deactivated data */}

      <Modal
        open={toggleuserInfo}
        onClose={() => {
          settoggleuserInfo(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={commentStyle}>
          <Box sx={{ height: 'fit-content' }} id="usersList-modal">
            <IconButton
              color="inherit"
              onClick={() => {
                settoggleuserInfo(false);
              }}
              sx={{
                position: 'absolute',
                right: 5,
                top: 0,
              }}
              aria-label="close"
            >
              <ClearIcon style={{ fontSize: 26 }} />
            </IconButton>
            <Typography id="modal-modal-title" variant="h6" component="h2" style={{ width: '95%' }}>
              Deactivated Notes
            </Typography>

            <div style={{ height: '250px', overflow: 'auto', marginTop: '10px' }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Date </TableCell>
                    <TableCell>Message</TableCell>
                    <TableCell>Added By</TableCell>
                  </TableRow>
                </TableHead>
                {loading ? (
                  ''
                ) : (
                  <TableBody>
                    {getDeactivateduserInfo?.length > 0 ? (
                      getDeactivateduserInfo?.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell> {formatDate(row?.createdDate)}</TableCell>
                          <TableCell>
                            {row?.description?.length > 30 ? (
                              <TooltipWithCopy text={row?.description} />
                            ) : (
                              row?.description
                            )}
                          </TableCell>
                          <TableCell> {row?.addedBy} </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow className="text-center">
                        <TableCell colSpan={3} style={{ textAlign: 'center' }}>
                          No record found
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                )}
              </Table>
            </div>
          </Box>
        </Box>
      </Modal>

      <HoursModal
        getUserId={getUserId}
        downloadData={downloadData}
        setincomeData={setincomeData}
        setSelectedYear={setSelectedYear}
        years={years}
        incomeData={incomeData}
        toggleHourModal={toggleHourModal}
        settoggleHourModal={settoggleHourModal}
        currentYear={currentYear}
      />

      <MultipleUsersPDF openPDFModal={openPDFModal} setOpenPDFModal={setOpenPDFModal} selectedUserId={selected} />

      <TablePagination
        rowsPerPageOptions={[100, 250, 500]}
        component="div"
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );

  const handleTabChange = (e, newValue) => {
    // Only clear search if the tab is actually changing (not on initial render)
    if (selectedTabValue !== newValue) {
      dispatch(clearSearch());
    }
    setPage(0);
    setSelected([]);
    dispatch(setReduxSelectedTabValue(newValue));
    setAllSelected(false);
  };

  return (
    <Page title="User">
      {(loading || isLoading) && <Loader />}
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Stack direction="row" justifyContent="space-between">
            <IconButton onClick={handleUserPageBackNavigation}>
              <Iconify icon="eva:arrow-back-fill" width={24} height={24} />
            </IconButton>
            <Typography variant="h4" sx={{ ml: 1 }} gutterBottom>
              Users
            </Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between">
            {selected && selected?.length > 0 && (
              <Tooltip arrow title={'Print'}>
                <Button style={{ marginLeft: '10px' }} variant="contained" onClick={() => setOpenPDFModal(true)}>
                  Print
                </Button>
              </Tooltip>
            )}

            <Tooltip arrow title={'Send Email'}>
              <Button
                style={{ marginLeft: '10px' }}
                variant="contained"
                onClick={() => setIsOpenModal({ sandEmail: true })}
              >
                Send Email
              </Button>
            </Tooltip>
             <Tooltip arrow title={'Download User Survey'}>
              <Button
                style={{ marginLeft: '10px' }}
                variant="contained"
                onClick={handleDownloadSurvey}
              >
               Download User Survey
              </Button>
            </Tooltip>
          </Stack>
        </Stack>

        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={isSnackBarOpen}
          autoHideDuration={autoHideDuration}
          onClose={handleSnackBarClose}
        >
          <Alert onClose={handleSnackBarClose} severity={alertStatus} sx={{ width: '100%' }}>
            {alertMessage}
          </Alert>
        </Snackbar>
        <Card>
          <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={selectedTabValue}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={(e, newValue) => handleTabChange(e, newValue)} aria-label="lab API tabs example">
                  <Tab label="ACTIVE" value="2" />
                  <Tab label="INACTIVE" value="3" />
                  <Tab label="ALL" value="1" />
                  <Tab label="PASSIVE" value="4" />
                  <Tab label="PERMANENT DEACTIVATED USERS" value="5" />
                </TabList>
              </Box>
              <TabPanel value="1" sx={{ padding: 0 }}>
                {renderUsers()}
              </TabPanel>
              <TabPanel value="2" sx={{ padding: 0 }}>
                {renderUsers()}
              </TabPanel>
              <TabPanel value="3" sx={{ padding: 0 }}>
                {renderUsers()}
              </TabPanel>
              <TabPanel value="4" sx={{ padding: 0 }}>
                {renderUsers()}
              </TabPanel>
              <TabPanel value="5" sx={{ padding: 0 }}>
                {renderUsers()}
              </TabPanel>
            </TabContext>
          </Box>
        </Card>
      </Container>
    </Page>
  );
}
